export const appLaunchUrlToPath = (
    appLaunchUrl: string
): string | undefined => {
    const url = new URL(appLaunchUrl);
    // The hash is carried through as well as the search: app.refsix.com is
    // claimed by both apps as a universal/app link, so a link meant for the web
    // app can open here instead, and anything carried in the fragment would
    // otherwise be silently dropped.
    return url.pathname + url.search + url.hash;
};
